import Swiper, {Pagination} from "swiper";
Swiper.use([Pagination]);

export const productSwipers = () => {
  if (window.matchMedia("(max-width: 767px)").matches) {
    const swiperProduct = new Swiper(`.js-swiper-product`, {
      spaceBetween: 10,
      slidesPerView: 1,
      pagination: {
        el: ".control-pagination",
        bulletClass: "control-pagination__item",
        bulletActiveClass: "control-pagination__item--active",
      },
    });
  }
};
